import * as React from "react";
import { Loader } from "react-feather";
import styles from "../NGProviderBrowser.module.scss";

export const BrowserLoading: React.FC = React.memo(() => {
  return (
    <div className={styles.loadingContainer}>
      <Loader className={styles.loadingSpinner} size={24} />
    </div>
  );
});

BrowserLoading.displayName = "BrowserLoading";
